export default {
  th_transaction_history: 'Transaction history',
  th_failed_to_load_tx: 'Failed to load history',
  th_no_transaction_history: 'You haven’t made any transactions yet',
  th_here_will_be_the_list: 'Here will be the list of your transactions',
  th_no_transaction_history_search: 'Try searching out by other assets or ',
  th_no_transaction_history_search_end: ' if you have any questions',
  th_no_assets_in_your_wallet: 'No assets in your wallet',
  th_no_balances_in_your_wallet: 'No balances in your wallet for exchange',
  th_no_currencies_in_your_wallet: 'No assets in your wallet which would be allowed for convert',
  th_here_will_be_tokens: 'Here will be the list of your assets',
  th_sub: 'Add',
  th_export_btn: 'Export',
  th_export_popup_title: 'Export Transactions',
  th_export_popup_text: 'Select the desired filters'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/tx-history_view.js